/*
 * @Author: czj
 * @Date: 2025-03-28 16:32:15
 * @Description: 
 * @FilePath: \test-demo2\src\utils\tool.js
 */

export function transformData(data) { //对象转数组
  return Object.entries(data).map(([key, value]) => ({
    label: key,
    value: value
  }));
};


export function getQueryParams(url) { // 获取url中的参数
  const urlObj = new URL(url);
  const params = new URLSearchParams(urlObj.search);
  return Object.fromEntries(params.entries());
};

export function flattenReportData(data) { // 扁平化测试报告数据
  const flattened = [];
  function traverse(node, path = []) {
    // 当前节点
    const current = {
      ...node
    };
    flattened.push(current);
    // 遍历子节点
    if (node.result && node.result.length > 0) {
      node.result.forEach(child => traverse(child, current.path));
    }
  }
  // 遍历根节点
  data.forEach(node => traverse(node));
  return flattened;
};

export function filterDataByAppnameAndType(data) { //过滤流程参数
  if (!data) return [];
  return Object.entries(data).filter(([key, item]) => {
    // 检查 appname 是否为空，并且 type 是否等于 "input"
    return !item.appname && item.type === "input";
  }).map(([key, item]) => ({ key, ...item }));
};


export function filterDataByAppnameAndTypeAndShow(data) { //过滤流程全部参数
  if (!data) return [];
  return Object.entries(data).filter(([key, item]) => {
    // 检查 appname 是否为空，并且 type 是否等于 "input"
    return !item.appname && item.type === "input" && item.is_show;
  }).map(([key, item]) => ({ key, ...item }));
};

export function filterDataInput(data) { //过滤流程输入参数
  if (!data) return [];
  return Object.entries(data).filter(([key, item]) => {
    // 检查 appname 是否为空，并且 type 是否等于 "input"
    return item.type === "input";
  }).map(([key, item]) => ({ key, ...item }));
};

export function formatFormData(formData) { // 格式化流程参数数据
  const result = formData.map(item => {
    const modifiedKey = item.key.replace(/\./g, '-');
    // 处理 dependency 内部的 key
    if (item.dependency) {
      // 处理多条件依赖（如 conditions）
      if (item.dependency.conditions) {
        item.dependency.conditions = item.dependency.conditions.map(condition => {
          return { ...condition, key: condition.key.replace(/\./g, '-') };
        });
      } else {
        // 处理单一依赖
        item.dependency.key = item.dependency.key.replace(/\./g, '-');
      }
    }
    return { ...item, key: modifiedKey, raw_key: item.key };
  });
  return result;
};

export function validateArray(arr) { //判断是否流程参数
  // 判断是否为数组，且数组长度不为 0
  if (Array.isArray(arr) && arr.length > 0) {
    // 遍历数组中的每个对象，判断 appname 是否为空字符串
    const allAppNamesEmpty = arr.every(item => !item.appname);
    // 如果所有 appname 都是空字符串，返回 true；否则返回 false
    return allAppNamesEmpty;
  } else {
    // 如果不是数组或数组为空，返回 false
    return false;
  }
};

export function restoreFormKeys(formData) { // 还原表单数据中的key
  const result = {};
  Object.keys(formData).forEach(key => {
    // 将 key 中的 "-" 替换为 "."
    const restoredKey = key.replace(/-/g, '.');
    result[restoredKey] = formData[key];
  });
  return result;
};


export function transformToCascaderData(select_data) { // 转换为级联选择器数据
  return Object.keys(select_data).map(key => {
    return {
      label: key,
      value: key,
      children: select_data[key].map(item => ({
        label: item,
        value: item
      }))
    };
  });
};

export function findMatchingFormEntries(formData, nodeData) { //过滤节点参数
  if (!formData) return [];
  return Object.entries(formData).filter(([key, formEntry]) => {
    return nodeData.some(node =>
      formEntry.appname && node.task_name && formEntry.appname === node.task_name && formEntry.type === "input"
    );
  }).map(([key, formEntry]) => ({ key, ...formEntry }));
};

export function findMatchingLineEntries(formData, nodeData) { //过滤节点连线参数
  if (!formData) return [];
  let result = Object.entries(formData).filter(([key, formEntry]) => {
    return nodeData.some(node =>
      formEntry.appname && node.task_name && formEntry.appname === node.task_name && formEntry.type === "lineInput"
    );
  }).map(([key, formEntry]) => ({ key, ...formEntry }));
  return result;
};

export function findMatchingResultEntries(formData, nodeData) { //过滤节点结果文件
  if (!formData) return [];
  let result = Object.entries(formData).filter(([key, formEntry]) => {
    return nodeData.some(node => node.w_task_param_name && node.w_task_param_name == key);
  }).map(([key, formEntry]) => ({ key, ...formEntry }));
  return result;
};


export function separateFiles(data) {
  const pdfFiles = {};
  const pictureFiles = {};
  let imgBase = null;
  const isBase64Image = (str) => str.startsWith('data:image/');
  const isBase64Svg = (str) => str.startsWith('data:image/svg+xml');
  if (typeof data === 'object' && !Array.isArray(data)) {
    // 如果是对象类型，遍历数据并根据文件扩展名将文件分类
    for (const [key, value] of Object.entries(data)) {
      if (value.endsWith('.pdf')) {
        pdfFiles[key] = value;
      } else {
        pictureFiles[key] = value;
      }
    }
  } else if (typeof data === 'string') {
    // 如果是单个字符串类型的数据，判断是 base64 img 还是 svg
    if (isBase64Svg(data)) {
      pictureFiles['svg_base64'] = data; // 随便定义一个 key
    } else if (isBase64Image(data)) {
      imgBase = data; // 赋值给 imgBase 变量
    }
  };
  return {
    pdfFiles: Object.keys(pdfFiles).length === 0 ? null : pdfFiles,
    pictureFiles: Object.keys(pictureFiles).length === 0 ? null : pictureFiles,
    imgBase: imgBase // 返回 imgBase 变量
  };
};